import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Typography, Box } from '@mui/material';

const Metadata = () => {
  const resources = [
    { href: "https://wedocs.unep.org/handle/20.500.11822/44825", src: "/carbon2.png", alt: "Carbon Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46449", src: "/energy2.png", alt: "Energy Icon" }, 
    { href: "https://wedocs.unep.org/20.500.11822/46450", src: "/land2.png", alt: "Land Icon" },
    { href: "https://wedocs.unep.org/handle/20.500.11822/44824", src: "/material2.png", alt: "Material Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46451", src: "/water2.png", alt: "Water Icon" },  
   
  ];

  return (
    <div className="container-fluid">
      <style>
        {`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
        body {
          font-family: 'Roboto';
        }
          .container-fluid {
            padding-right: 0 !important;
            padding-left: 0 !important;
          }
          .thematic-banner img {
            display: block;
            margin: 0 auto;
          }
          .accordion-body {
            --bs-accordion-body-padding-x: 0 ! important;
            --bs-accordion-body-padding-y: 0 !important;
          }
          .metadatapara {
            padding:1em ! important;
          }
          p {
            text-align: left; 
          }
        `}
      </style>
  
      {/* Banner Image: Only visible when Home link is active */}
      <div className="thematic-banner">
        <img src="/Banner 4.png" alt="Thematic Banner" style={{ width: '100%', height: '350px', }}/>
      </div>  
      <div className="container" style={{ textAlign: 'justify',  position: 'center' }}>
      <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
         Metadata
        </h3> 
      <p variant="body1" paragraph sx={{ textAlign: 'left' }}>
      Detailed information, including the methodology used, on five footprint indicators: Carbon Footprint, Energy Footprint, Land Use Footprint, Material Footprint, and Water Consumption Footprint, is provided in the corresponded metadata. 
      </p>   
    </div>
    <div className="container" style={{ textAlign: 'justify',  position: 'center' }}>
    <div className="row gx-4 justify-content-md-center accordion" id="footprintAccordion" style={{paddingBottom: '4em'}}> 
        {/* Carbon */}
        
        <div  id="collapseCarbon"   className="accordion-collapse collapse show" aria-labelledby="headingCarbon" data-bs-parent="#footprintAccordion">
            <div className="accordion-body text-center">        
              {/* Card */}
              <div className="card mx-auto mb-4 shadow-sm">
                <div className="row g-0">
                <div className="col-md-12 metadatapara">
                <img src="/CF Icon.png" alt="Energy" style={{float: 'left', width: '7%', marginRight: '10px', marginBottom: '10px'}}/>
                <p> <strong>Carbon Footprint</strong> is the attribution of global greenhouse gas emissions to the domestic final demand of a country. The total carbon footprint is the sum of the carbon footprint for carbon dioxide, methane, nitrous oxide, hydrofluorocarbons, perfluorocarbons, sulphur hexafluoride, and nitrogen trifluoride.  
                  </p>
                <p>
                  <a href="https://wedocs.unep.org/handle/20.500.11822/44825"  target="_blank" rel="noopener noreferrer">Read More</a>
                </p>                      
              </div>                                 
             </div>
            </div>     
            </div>
          </div>       
        {/* Energy */} 
       
        <div id="collapseEnergy"  className="accordion-collapse collapse show"  aria-labelledby="headingEnergy"  data-bs-parent="#footprintAccordion">
            <div className="accordion-body">          
              {/* Card */}
              <div className="card mx-auto mb-4 shadow-sm">
                <div className="row g-0 align-items-center">
                  <div className="col-md-12 metadatapara">
                <img src="/EF Icon.png" alt="Energy" style={{float: 'left', width: '7%', marginRight: '10px', marginBottom: '10px'}}/>
                <p>  <strong>Energy Footprint</strong> is the attribution of global primary energy production to the domestic final demand of a country. The total energy footprint is the sum of the energy footprint for coal and peat, oil and natural gas, nuclear, solid biofuels, captured energy and heat.
                      </p>
                      <p>
                  <a href="https://wedocs.unep.org/20.500.11822/46449"  target="_blank" rel="noopener noreferrer">Read More</a>
                </p>                      
              </div>                
              </div>
              </div>         
            </div>
          </div>
            {/* Land */}
           
        <div id="collapseLand" className="accordion-collapse collapse show" aria-labelledby="headingLand" data-bs-parent="#footprintAccordion">
            <div className="accordion-body">           
              {/* Card */}
              <div className="card mx-auto mb-4 shadow-sm">
                <div className="row g-0 align-items-center">
                <div className="col-md-12 metadatapara">
                <img src="/LF Icon.png" alt="Energy" style={{float: 'left', width: '7%', marginRight: '10px', marginBottom: '10px'}}/>
                <p>  <strong>Land Use Footprint</strong> is the attribution of global land use to the domestic final demand of a country. The total land use footprint is the sum of the land use footprint for agricultural and forestry land use, and built-up land.
                      </p>
                      <p>
                  <a href="https://wedocs.unep.org/20.500.11822/46450"  target="_blank" rel="noopener noreferrer">Read More</a>
                </p>                      
              </div>   
            </div>
           </div>           
          </div>
          </div>       
        {/* Material */}         
        <div id="collapseMaterial" className="accordion-collapse collapse show" aria-labelledby="headingMaterial" data-bs-parent="#footprintAccordion">
            <div className="accordion-body" sx={{ padding: '0'}}>          
              {/* Card */}
              <div className="card mx-auto mb-4 shadow-sm">
                <div className="row g-0 align-items-center">
                <div className="col-md-12 metadatapara">
                <img src="/MF Icon.png" alt="Energy" style={{float: 'left', width: '7%', marginRight: '10px', marginBottom: '10px'}}/>
                <p>  <strong>Material Footprint</strong> is the attribution of global material extraction to domestic final demand of a country. The total material footprint is the sum of the material footprint for biomass, fossil fuels, metal ores and non-metallic minerals.
                      </p>
                      <p>
                  <a href="https://wedocs.unep.org/handle/20.500.11822/44824"  target="_blank" rel="noopener noreferrer">Read More</a>
                </p>                      
              </div>
                </div>
              </div>      
            </div>
          </div>        
        {/* Water */}         
        <div id="collapseWater"  className="accordion-collapse collapse show" aria-labelledby="headingWater" data-bs-parent="#footprintAccordion">
            <div className="accordion-body">           
              {/* Card */}
              <div className="card mx-auto mb-4 shadow-sm">
                <div className="row g-0 align-items-center">
                <div className="col-md-12 metadatapara">
                <img src="/WF.png" alt="Energy" style={{float: 'left', width: '7%', marginRight: '10px', marginBottom: '10px'}}/>
                <p>  <strong>Water Consumption Footprint</strong> is the attribution of global freshwater consumption to the domestic final demand of a country.
                      </p>
                      <p>
                  <a href="https://wedocs.unep.org/20.500.11822/46451"  target="_blank" rel="noopener noreferrer">Read More</a>
                </p>                      
              </div>
              </div>
              </div>           
            </div>
          </div>
        
      </div>
      </div>
    </div>
  );  
};

export default Metadata;
